/*
 * This page will be displayed on the Audi Nemo site inside an iframe
 */

import React from 'react';
import cn from 'classnames';
import moment from 'moment';
import Button from '../audi-ui-components/Button';
import Checkbox from '../audi-ui-components/Checkbox';
import Select from '../audi-ui-components/Select';
import Dropdown from '../audi-ui-components/Dropdown';
import FramedPagination from '../components/FramedPagination';
import { renderCourseDates } from '../lib/helpers';
import { Helmet } from 'react-helmet';
import queryString from 'query-string';
import {
    PATH_COURSE,
    FEATURE_TOGGLE,
    DEFAULT_THEME,
} from '../constants';

const today = moment();

const stateOpts = [
    {label: "show all", value: "all"},
    {label: "New South Wales", value: "nsw"},
    {label: "Victoria", value: "vic"},
    {label: "South Australia", value: "sa"},
    {label: "Northern Territory", value: "nt"},
    {label: "Western Australia", value: "wa"},
    {label: "Queensland", value: "qld"},
    {label: "Tasmania", value: "tas"},
    {label: "Australian Capital Territory", value: "act"}
];
const stateConvert = {
  nsw: "new south wales",
  vic: "victoria",
  sa: "south australia",
  nt: "northern territory",
  wa: "western australia",
  qld: "queensland",
  tas: "tasmania",
  act: "australian capital territory"
};

class NemoCoursesPage extends React.Component {

    constructor(props) {
        super(props);
        let query = queryString.parse(props.location.search);
        this.state = {
            activeTab: "current",
            isFetchingData: true,
            fullList: [],
            filteredList: [],
            paginatedList: [],
            programOpts: [],
            hostname: "",
            filterState: query.state ? query.state.toLowerCase() : "",
            filterSlug: query.program ? query.program.toLowerCase().split(",") : [],
            showPast: Boolean(query.showPast && query.showPast === "true"),
            pageIdx: null
        };
        this.pageSize = query.pageSize || 10;
    }

    componentDidMount() {
        let q = queryString.parse(this.props.location.search);
        let theme = q.theme || DEFAULT_THEME;
        if (theme === "dark") {
            document.body.classList.add("theme-dark");
        }
        let pastmonths = q.pastMonths ? q.pastMonths : 6;
        let dir = (q.order && q.order === "asc" || q.order === "desc") ? q.order : "asc";
        this.setState({
            isFetchingData: true,
            hostname: window.location.protocol + "//" + window.location.hostname
        });
        let d = moment().subtract(pastmonths, 'months').toISOString();
        fetch(
            `${process.env.RAZZLE_ADE_API}/2/experiences/list?$orderby=startDate ${dir}&$count=true&$filter=cast(startDate,'Edm.DateTimeOffset') ge ${d} and status eq 'Active' and isPrivate eq false and program/isPrivate eq false and venue/isPrivate eq false`,
            {method: 'GET', headers: {Accept: 'application/json', 'Cache-Control': 'no-cache'}}
        ).then((response) => {
            if (response.status >= 400) {
                let error = new Error(response.statusText);
                error.response = response;
                error.status = response.status;
                throw error;
            }
            return response.json();
        }).then((list) => {
            let slugs = [];
            let opts = [];
            list.forEach((item, idx, arr) => {
                item.momentStart = moment(item.startDate);
                item.momentEnd = moment(item.endDate);
                item.bookingStatus = "open";
                if (item.momentEnd.isBefore(today)) {
                    item.bookingStatus = "closed";
                } else if (item.totalSeats > 0 && item.bookedSeats >= item.totalSeats) {
                    item.bookingStatus = "soldout";
                } else if (item.totalSeats === 0) {
                    item.bookingStatus = "pending";
                }
                if (item.program?.slug) {
                    item.program.slugLower = item.program.slug.toLowerCase();
                    if (slugs.indexOf(item.program.slugLower) === -1) {
                        slugs.push(item.program.slugLower);
                        opts.push({label: item.program.name, value: item.program.slugLower});
                    }
                }
            });
            // --- TEST DATA ---
            if (q.addTestData === "true") {
                const testCategories = [
                    { status: "open",    totalSeats: 20, bookedSeats: 5  }, // Book now
                    { status: "soldout", totalSeats: 20, bookedSeats: 20 }, // Sold out
                    { status: "pending", totalSeats: 0,  bookedSeats: 0  }, // Coming soon
                    { status: "closed",  totalSeats: 20, bookedSeats: 10 }, // Past
                ];
                for (let i = 1; i <= 30; i++) {
                    const cat = testCategories[(i - 1) % testCategories.length];
                    const startDate = cat.status === "closed"
                        ? moment().subtract(i, 'days')
                        : moment().add(i * 3, 'days');
                    const endDate = startDate.clone().add(1, 'day');
                    list.push({
                        id: `test-${i}`,
                        program: { name: `Test Experience ${i}`, slug: "test-experience", slugLower: "test-experience" },
                        venue: { name: "Test Venue", slug: "test-venue", location: "Sydney, NSW" },
                        startDate: startDate.toISOString(),
                        endDate: endDate.toISOString(),
                        momentStart: startDate,
                        momentEnd: endDate,
                        startTime: startDate.format("h:mm A"),
                        endTime: endDate.format("h:mm A"),
                        totalSeats: cat.totalSeats,
                        bookedSeats: cat.bookedSeats,
                        bookingStatus: cat.status,
                    });
                }
            }
            // --- END TEST DATA ---
            this.setState({fullList: list, programOpts: opts, isFetchingData: false});
            this.filterList(list);
        }).catch((error) => {
            console.log(error);
            //
        });
    }
    
    componentDidUpdate(prevProps, prevState) {
        if (
          prevState.showPast !== this.state.showPast ||
          prevState.activeTab !== this.state.activeTab ||
          prevState.filterState !== this.state.filterState ||
          prevState.filterSlug.length !== this.state.filterSlug.length
        ) {
            this.filterList();
        }
        // if (prevState.pageIdx !== this.state.pageIdx) {
        //     this.paginateList();
        // }
    }
    
    filterList = (_list) => {
        // console.log("filtering");
        let list = _list;
        if (typeof _list === "undefined") {
            list = this.state.fullList;
        }
        let filtered = [];
        for (let i=0; i<list.length; i++) {
            let exp = list[i];
            let valid = true;
            if (this.state.filterState && this.state.filterState !== "all") {
                if (!exp.venue.state) {
                    valid = false
                } else if (
                    exp.venue.state.toLowerCase() !== this.state.filterState && 
                    exp.venue.state.toLowerCase() !== stateConvert[this.state.filterState]
                ) {
                    valid = false;
                }
            }
            if (valid && this.state.filterSlug && this.state.filterSlug.length > 0) {
                if (exp.program.slugLower && this.state.filterSlug.indexOf(exp.program.slugLower) === -1) {
                    valid = false;
                }
            }
            if (valid) {
                if (this.state.showPast) {
                    filtered.push(exp);
                } else if (this.state.activeTab === "current" && (exp.bookingStatus === "open" || exp.bookingStatus === "soldout")) {
                    filtered.push(exp);
                } else if (this.state.activeTab === "coming" && exp.bookingStatus === "pending") {
                    filtered.push(exp);
                }
            }
        }
        this.setState({filteredList: filtered, pageIdx: 0}, this.paginateList);
    }
    
    paginateList = () => {
    //   console.log("paginating");
      let start = this.pageSize * this.state.pageIdx;
      let paginated = this.state.filteredList.slice(start, start + this.pageSize);
      this.setState({paginatedList: paginated}, () => {
          requestAnimationFrame(() => {
              if (typeof window.sendHeight === 'function') {
                  window.sendHeight();
              }
          });
      });
    }

    render() {
        const {filteredList, paginatedList, isFetchingData, hostname, showPast} = this.state;
        let q = queryString.parse(this.props.location.search);
        let theme = q.theme || DEFAULT_THEME;
        return (
            <div className={cn("iframe-content iframe-table", {"theme-dark": theme === "dark", "theme-light": theme === "light"})}>
            <div className="iframe-content__inner">
            
                <Helmet>
                    <style>{`html { overflow: hidden; }`}</style>
                    <script>{`
                        var savedHeight = 0;
                        function sendHeight() {
                            var container = document.getElementById('AppContainer');
                            if (!container) return;
                            var appHeight = container.offsetHeight;
                            var activePanel = document.querySelector('.aui-dropdown.is-active .aui-dropdown__panel');
                            if (activePanel) {
                                var panelBottom = activePanel.getBoundingClientRect().bottom + window.pageYOffset;
                                var containerTop = container.getBoundingClientRect().top + window.pageYOffset;
                                appHeight = Math.max(appHeight, panelBottom - containerTop);
                            }
                            appHeight += 50;
                            if(appHeight !== savedHeight) {
                                savedHeight = appHeight;
                                var pxHeight = appHeight + "px";
                                var payload = { height : pxHeight, url: window.location.href };
                                window.parent.postMessage(JSON.stringify(payload), '*');
                            }
                        }
                        if (window && window.parent) {
                            sendHeight();
                            window.setInterval(sendHeight, 1000);
                            var observer = new MutationObserver(function() {
                                requestAnimationFrame(sendHeight);
                            });
                            if (document.body) {
                                observer.observe(document.body, {
                                    subtree: true,
                                    attributes: true,
                                    attributeFilter: ['class']
                                });
                            }
                        }
                    `}</script>
                </Helmet>

                {(FEATURE_TOGGLE.MAINTENANCE || FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE) && <div className="maintenance-note">
                    {!FEATURE_TOGGLE.MAINTENANCE && FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE && <div dangerouslySetInnerHTML={{__html: FEATURE_TOGGLE.PRE_MAINTENANCE_NOTE}}></div>}
                    {FEATURE_TOGGLE.MAINTENANCE && FEATURE_TOGGLE.MAINTENANCE_NOTE && <div dangerouslySetInnerHTML={{__html: FEATURE_TOGGLE.MAINTENANCE_NOTE}}></div>}
                </div>}
                
                <div className="d-flex justify-content-between pt-3 pb-4 filters">
                    {!this.state.showPast && <div style={{display: 'flex', alignItems: 'flex-end'}}>
                        {['current', 'coming'].map((tab, idx) => {
                            const isActive = this.state.activeTab === tab;
                            const activeColor = theme === 'light' ? '#000000' : '#ffffff';
                            const color = isActive ? activeColor : '#6b6b6b';
                            return (
                                <React.Fragment key={tab}>
                                    {idx > 0 && <div style={{width: '24px', height: 0, borderBottom: `2px solid ${activeColor}`}} />}
                                    <button
                                        type="button"
                                        onClick={() => this.setState({activeTab: tab})}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            borderBottom: `2px solid ${color}`,
                                            padding: '8px 0',
                                            fontFamily: "'AudiTypeExtended', Verdana, Geneva, sans-serif",
                                            fontSize: '18px',
                                            color: color,
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {tab === 'current' ? 'Current Experiences' : 'Coming soon'}
                                    </button>
                                </React.Fragment>
                            );
                        })}
                    </div>}
                    {(q.showPastCheckbox || q.showStateSelect || q.showProgramSelect) && <div className="filters-controls">
                        {q.showProgramSelect &&
                            <div className="filter-control">
                                <Dropdown
                                    name="filterSlug"
                                    label="Program"
                                    value={this.state.filterSlug}
                                    multiple
                                    onChange={(v,e) => { this.setState({filterSlug: v}); }}
                                    options={this.state.programOpts}
                                    theme={theme === "dark" ? "black" : null}
                                />
                            </div>
                        }
                        {q.showStateSelect &&
                            <div className="filter-control">
                                <Dropdown
                                    name="filterState"
                                    label="State"
                                    value={this.state.filterState}
                                    onChange={(v,e) => { this.setState({filterState: v}); }}
                                    options={stateOpts}
                                    theme={theme === "dark" ? "black" : null}
                                />
                            </div>
                        }
                        {q.showPastCheckbox &&
                            <div className="filter-control">
                                <Checkbox
                                    label="Show past experiences"
                                    checked={this.state.showPast}
                                    onChange={(v,e) => { this.setState({showPast: e.target.checked}); }}
                                    theme={theme === "dark" ? "light" : null}
                                />
                            </div>
                        }
                    </div>}
                </div>

                <div className="aui-table aui-table--stretched">
                    <table>
                        <thead>
                            <tr>
                                <th style={{width: q.showVenue ? '25%' : '30%'}}>Experience</th>
                                {q.showVenue && <th style={{width: '25%'}}>Location</th>}
                                <th style={{width: q.showVenue ? '35%' : '50%'}}>Date</th>
                                <th className="ctacol"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedList && paginatedList.map((exp) => {
                                let cta = null;
                                if (exp.bookingStatus === "open") {
                                  cta = (<Button variant="primary" theme={theme === "dark" ? "light" : null} className="red" href={`${hostname}/${PATH_COURSE}/${exp.program.slug}/${exp.venue.slug}/${exp.id}`} target="_blank" disabled={FEATURE_TOGGLE.MAINTENANCE}>Book now</Button>);
                                }
                                if (exp.bookingStatus === "closed") {
                                  cta = (<Button variant="primary" theme={theme === "dark" ? "light" : null} disabled>Completed</Button>);
                                }
                                if (exp.bookingStatus === "soldout" || exp.bookingStatus === "pending") {
                                  cta = (<Button variant="primary" theme={theme === "dark" ? "light" : null} href={`${process.env.RAZZLE_FORMS_URL}/ade-waitlist/${exp.id}`} target="_blank" className="red">Register your interest</Button>);
                                }
                                return (
                                    <tr key={`row_${exp.id}`} className="course-row">
                                        <td className="course-detail">
                                          <div>
                                            <p>{exp.program.name}</p>
                                          </div>
                                          <div className="course-cta-mobile">{cta}</div>
                                        </td>
                                        {q.showVenue && <td>{exp.venue.location}</td>}
                                        <td>
                                            {exp.momentStart.format("D MMMM YYYY")}
                                            {exp.momentEnd.isAfter(exp.momentStart, 'day') && <span> - {exp.momentEnd.format("D MMMM YYYY")}</span>}
                                            <div className="course-time" style={{fontSize: '12px', marginTop: '12px'}}>{exp.startTime} - {exp.endTime}</div>
                                            {exp.bookingStatus === "soldout" && <p className="mt-2 aui-color-text-red"><b>Sold Out</b></p>}
                                        </td>
                                        <td className="text-right course-cta-desktop">{cta}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {filteredList.length > this.pageSize && this.state.pageIdx !== null && <div className="d-flex justify-content-end mt-3">
                      <FramedPagination activeIndex={this.state.pageIdx} totalSteps={Math.ceil(filteredList.length / this.pageSize)} onChange={(idx) => { this.setState({pageIdx: idx}, this.paginateList); }} theme={theme === "dark" ? "light" : null} />
                    </div>}
                    {!isFetchingData && (!filteredList || filteredList.length === 0) && <div className="py-5 text-center">
                        No experiences are currently available. Please check back later.
                    </div>}
                </div>
            </div>
            </div>
        );
    }
}

export default NemoCoursesPage;
